import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment.dev";
import { BaseService } from "../../@core/services/base.service";

export interface IClauseBundleWithClauses {
    _id: string;
    organization: string;
    workspace: string;
    name: string;
    clauses: { _id: string; name: string; text?: string }[];
    createdAt?: string;
    updatedAt?: string;
}

export interface IClauseBundle {
    _id: string;
    organization: string;
    workspace: string;
    name: string;
    clauses?: { _id: string; name: string; text?: string }[] | string[];
    createdAt?: string;
    updatedAt?: string;
}

export interface IBundleFilterOptions {
    id: string;
    name: string;
}

@Injectable({ providedIn: 'root' })
export class ClauseBundleService extends BaseService {

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    apiUrl = environment.apiUrl + '/clause-library/bundles';

    createBundle(name: string) {
        return this.post<IClauseBundle>(this.apiUrl + '/', { name });
    }

    getBundles(
        filters?: { searchValue?: string; skip?: number; limit?: number },
        populateClauses?: boolean
    ) {
        return this.post<{ bundles: IClauseBundle[] | IClauseBundleWithClauses[]; total: number }>(
            this.apiUrl + '/list',
            { filters: filters || {}, populateClauses: !!populateClauses }
        );
    }

    getBundleFilterOptions() {
        return this.get<{ bundles: IBundleFilterOptions[] }>(this.apiUrl + '/filter-options');
    }

    updateBundle(id: string, body: { name?: string }) {
        return this.put<IClauseBundle>(this.apiUrl + '/' + id, body);
    }

    deleteBundle(id: string) {
        return this.delete(this.apiUrl + '/' + id);
    }
}
